import types from './types';
import globalTypes from '../globalTypes';
import API from '../../utils/api';
import Cookies from 'react-cookies';
import WSocket from '../../utils/websocket';
import SoundsUtil from '../../utils/sounds';
import language from '../../language';

export const authorize = data => async dispatch => {
    SoundsUtil.click();

    dispatch({
        type: types.error,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'auth'
    });

    const response = await API({
        path: '/user/auth/login',
        body: data
    });

    if(response.success) {
        const user_response = await API({
            path: '/user/get'
        });

        if(user_response.success) {
            if(user_response.user)
                WSocket.authorize(user_response.user.userId, false);

            dispatch({
                type: globalTypes.user.loaded,
                payload: user_response
            });
        }
    } else {
        dispatch({
            type: types.error,
            payload: language(response.error)
        });
    }

    dispatch({
        type: types.toggleButton,
        payload: 'auth'
    });
}

export const logout = navigate => async dispatch => {
    Cookies.remove('access_token');
    WSocket.logout();

    const main_element = document.querySelector('.main-page');

    if(!main_element)
        return window.location.pathname = '/';

    const header = main_element.querySelector('.header'),
          bottom = main_element.querySelector('.bottom'),
          gameContainer = main_element.querySelector('.game-container'),
          tabsContainer = main_element.querySelector('.tabs-container'),
          toolbar = main_element.querySelector('.toolbar');

    if(header && bottom && gameContainer && tabsContainer && toolbar) {
        header.classList.remove('animate__fadeInDown');
        header.classList.add('animate__fadeOutUp');

        bottom.classList.remove('animate__fadeInUp');
        bottom.classList.add('animate__fadeOutDown');

        gameContainer.classList.remove('animate__fadeIn');
        gameContainer.classList.add('animate__fadeOut');

        tabsContainer.classList.remove('animate__fadeIn');
        tabsContainer.classList.add('animate__fadeOut');

        toolbar.classList.remove('animate__fadeInRight');
        toolbar.classList.add('animate__fadeOutRight');
    }

    setTimeout(() => {
        dispatch({
            type: globalTypes.user.logout
        })

        navigate('/login');
    }, 900);
}

export const guest = () => async dispatch => {
    SoundsUtil.click();

    dispatch({
        type: types.error,
        payload: null
    });

    dispatch({
        type: types.toggleButton,
        payload: 'guest'
    });

    const response = await API({
        path: '/user/guest'
    });

    if(response.success) {
        dispatch({
            type: globalTypes.user.loaded,
            payload: response
        });
    } else {
        dispatch({
            type: types.error,
            payload: language(response.error)
        });
    }

    dispatch({
        type: types.toggleButton,
        payload: 'guest'
    });
}